var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-questions"},_vm._l((_vm.allQuestions),function(question){return _c('div',[_c('item-questions',{attrs:{"question_item":question}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }